module.exports = __webpack_public_path__ + "static/media/blog2.9cd58912.jpg";